<template>
  <div>
    <v-row v-if="current.user_level=='ADMIN'">
      <v-col>        
        <v-select
          :items="api.schools"
          :item-text="selectLabel('schools')"
          item-value="school_id"
          v-model="current.school_id"
          :label="selectLabel('label')"
          :disabled="current.user_level!='ADMIN'"
          @change="goTo(current.school_id)"
        ></v-select>
      </v-col>
    </v-row>    
		<div class="ma-4">
			<h4 class="my-5">{{ $t("manage.header") }}</h4>
    </div>
    <router-view :key="componentKey"></router-view>
  </div>
</template>
<script>

import {api_general} from '@/services/iot/api_general';
const apiGeneral = new api_general(process.env.VUE_APP_BASE_URL);

export default {
  name: "school",
  data: function () {
    return {
      componentKey: 0,
      name: "",
      role: null,
      drawer: true,
      mini: true,
      school: null,
      current: {
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
      },
      api: {
        schools: {}
      },
    };
  },
  mounted: function () {
    var self = this;
    self.init();
    //self.getSchoolFromSchoolList();    
  },
  methods: {    
    init(){
      var self = this;
      self.current.school_id = self.$route.params.school_id;
      self.current.username = self.$store.state.user.username;
      self.current.user_level = self.$store.state.user.user_level;
      self.current.auth_token = self.$store.state.user.auth_token;
      
      if(self.current.user_level != "ADMIN" ){
        self.api.schools = [self.current.school_id];
        self.getUserSchool();
      }
      else {
        self.getSchoolList();
      }
    },
    getUserSchool(){
      var self = this;
      apiGeneral.getUserSchool(self.$cookies.get('username')).then((response) => {
        if(response.status=="success" && self.$route.params.school_id!=response.school){
          self.goTo(response.school);
          //self.$router.push("/management/school/"+response.school+"/");
        }
      });
    },
    getSchoolList(){
      var self = this;
      apiGeneral
        .getSchoolList()
        .then((response) => {
          self.api.schools = response.schools;
      });
    },
    selectLabel(label){
      var self = this;
      if(self.$i18n.locale=='tc'){
        if (label=='label') return "請選擇學校ID"
        else if (label=='schools') return "id_chi_name"
      }
      else {
        if (label=='label') return "Please select a School ID"
        else if (label=='schools') return "id_name"
      }
    },
    goTo: function (school) {
      var self = this;
      self.$router.push("/management/school/"+school);
      self.init();
      self.componentKey+=1;
    },
  },
  destroyed(){
  }
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>